import { isDev } from "../app/env";
import {
  DniImageType,
  DocumentRepresentativeType,
  DocumentType,
  JuridicalShareholder,
} from "../types";

export const PERCENTAGE_DECIMALS = 2;

export const firestoreCollections = {
  dni: "dniImages",
  dniSignatory: "dniImagesSignatory",
  dniCoowner: isDev ? "dniImagesCoownerDev" : "dniImagesCoownerProd",
  liveness: "livenessValidation",
  livenessSignatory: "livenessValidationSignatory",
  livenessCoowner: isDev
    ? "livenessValidationCoownerDev"
    : "livenessValidationCoownerProd",
  emailValidation: "emailValidation",
  dniCrypto: isDev ? "dniImagesCryptoDev" : "dniImagesCryptoProd",
  livenessCrypto: isDev
    ? "livenessValidationCryptoDev"
    : "livenessValidationCryptoProd",
};

// Días hasta que la Cloud Function `cleanupRenaper` (functions/) borra un documento
// dniImages* o livenessValidation* que nadie volvió a tocar, con los datos personales que
// pudiera tener. El front escribe `expiresAt` al crear el documento. Coincide con la
// expiración de las validaciones en midgard (30 días): pasado ese plazo hay que rehacer el
// escaneo y el liveness igual.
export const FIRESTORE_KYC_DOC_TTL_DAYS = 30;

// docs mapped to the backend document types
export const documentTypesParsed: Record<
  DniImageType | string,
  DocumentType | DocumentRepresentativeType
> = {
  frontDNI: "DNI_FRONT",
  backDNI: "DNI_BACK",
};

export const DNI_SCAN_POLLING_INTERVAL_MS = 2000;
export const DNI_SCAN_POLLING_TIMEOUT_MS = 60000;

// Minimum age to open a Securities account
export const MIN_HOLDER_AGE = 18;

export const showOnlyInDev = isDev;

export const emptyPhysicalShareholder = {
  personType: "PHYSICAL",
  name: "",
  lastName: "",
  citizenship: "",
  birthDate: "",
  civilStatus: "",
  address: {
    country: "",
    fullAddress: "",
    street: "",
    city: "",
    state: "",
    municipality: "",
    zipCode: "",
  },
  activities: "",
  taxType: "CUIT",
  taxId: "",
  ownership: "",
  foreignTaxDetail: {
    idNumber: "",
    address: {
      fullAddress: "",
      country: "",
      street: "",
      city: "",
      state: "",
      zipCode: "",
    },
  },
  pep: "",
};

export const emptyJuridicalShareholder: JuridicalShareholder = {
  personType: "JURIDICAL",
  legalName: "",
  taxType: "CUIT",
  taxId: "",
  ownership: "",
  foreignTaxDetail: {
    idNumber: "",
    address: {
      fullAddress: "",
      country: "",
      street: "",
      city: "",
      state: "",
      zipCode: "",
    },
  },
};
